import { css } from 'aphrodite';
import * as React from 'react';
import { IActionButton } from './ActionBarButtonTypes';
import { styleSheet } from './styles';

export const ActionBarButton: React.FC<IActionButton> = ({
	icon,
	children,
	onClick,
	disabled,
	styleClass,
	isFullWidth,
}) => {
	const isIconOnly = !children;
	return (
		<button
			className={css(
				styleSheet.actionButton,
				isIconOnly && styleSheet.actionButtonIconOnly,
				disabled ? null : styleSheet.actionButtonEnabled,
				styleClass,
				isFullWidth && styleSheet.fullWidth
			)}
			onClick={onClick}
			disabled={disabled}
		>
			{icon}
			{children && <span className={css(styleSheet.buttonText)}>{children}</span>}
		</button>
	);
};
